import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useContent } from '../../hooks/useContent';

interface LogoProps {
  size?: number;
  showText?: boolean;
  animate?: boolean;
  asLink?: boolean;
}

export default function Logo({ size = 40, showText = true, animate = false, asLink = true }: LogoProps) {
  const { content: siteContent } = useContent();
  const l = siteContent?.logo;
  const imgEl = (
    <img
      src="/vaastu-icon.png"
      alt="The Perfect Vaastu"
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        borderRadius: '50%',
        border: '1.5px solid #E8871A',
        boxShadow: '0 0 10px rgba(232,135,26,0.35)',
        background: '#0D0D1F',
        display: 'block',
      }}
    />
  );

  const content = (
    <>
      {animate ? (
        <motion.div
          animate={{ rotate: [0, 5, -5, 0] }}
          transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
        >
          {imgEl}
        </motion.div>
      ) : imgEl}

      {showText && (
        <div>
          <p style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: size * 0.4,
            color: '#E8871A',
            lineHeight: 1.1,
            whiteSpace: 'nowrap'
          }}>
            {l?.name ?? 'The Perfect Vaastu'}
          </p>
          <p style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: size * 0.18,
            color: '#FDF6EC',
            opacity: 0.5,
            letterSpacing: 2,
            marginTop: 2
          }}>
            {l?.consultant ?? 'DR. RAGHAV TAPARIA'}
          </p>
        </div>
      )}
    </>
  );

  if (!asLink) {
    return <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>{content}</div>;
  }

  return (
    <Link to="/" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      {content}
    </Link>
  );
}
